import { COLORS } from '../constants/theme';

export const drawContactFooter = (engine) => {
    const doc = engine.getDoc();
    const cursor = engine.getCursor();
    const pageManager = engine.getPageManager();

    let footerY = cursor.getY() + 10;

    // If the contact us footer doesn't fit on the page, break page
    if (footerY + 120 > 740) {
        pageManager.addPage({ drawTermsCard: true, resetYTo: 50 });
        footerY = 50;
    }

    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.TEXT_DARK_GRAY);
    doc.text("Contact Us :", 45, footerY + 18);

    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS.TEXT_BODY_GRAY);
    doc.text("Daniel Farago : Danny@venettini.com", 45, footerY + 32);
    doc.text("Patricia Farago : Patricia@venettini.com", 45, footerY + 44);

    doc.setFont('Helvetica', 'bold');
    doc.setTextColor(...COLORS.TEXT_DARK_GRAY);
    doc.text("Office and accounting.", 45, footerY + 62);

    doc.setFont('Helvetica', 'normal');
    doc.setTextColor(...COLORS.TEXT_BODY_GRAY);
    doc.text("Vera Vera@venettini.com", 45, footerY + 76);
    doc.text("305-477-4011 OFFICE", 45, footerY + 88);

    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(...COLORS.TEXT_DARK_GRAY);
    doc.text("Thank you for your order.", 45, footerY + 110);

    // Draw final page footer number
    pageManager.drawPageFooterNumber();

    const endY = footerY + 110;
    cursor.setY(endY);
    return endY;
};
